import React, { useState, useEffect } from 'react';
import Select from 'react-select';

export default ({ optionsProp = [], selectedNewOptionHandler }) => {
    const [options, setOptions] = useState(optionsProp);
    const [selectedValue, setSelectedValue] = useState(null);

    const handleChange = (value) => {
        setSelectedValue(value);
        selectedNewOptionHandler(value);
        // console.log('value', value)
        if (value) {
            setTimeout(() => {
                setSelectedValue(null);
            }, 500);
        }
    };

    useEffect(() => {
        setOptions(optionsProp);
    }, [optionsProp])
    return (
        <Select
            className="basic-single"
            classNamePrefix="select"
            isClearable
            isSearchable
            name="single-select"
            options={options}
            onChange={handleChange}
            placeholder="Select an option..."
            value={selectedValue}
        />
    );
};